var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-radio-group',{attrs:{"label":_vm.label,"column":""},on:{"change":function($event){return _vm.updateField()}},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}},_vm._l((_vm.dataSource),function(option){return _c('v-radio',{key:option.id,attrs:{"value":option.id,"label":option.value}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }